export interface CantonData {
  name: string
  count: number
  avgPrice: number
  totalValue: number
}

export interface CityData {
  name: string
  count: number
  avgPrice: number
}

export interface CantonTransactionType {
  canton: string
  transactions: number
  types: Record<string, number>
}

export interface GeographicDistributionData {
  byCanton: CantonData[]
  topCities: CityData[]
  cantonTransactionTypes: CantonTransactionType[]
  totalTransactions: number
}

export interface GeographicDistributionChartLabels {
  activeCantons?: string
  totalTransactions?: string
  avgTransactionPrice?: string
  totalMarketVolume?: string
  transactionsByCanton?: string
  topCitiesByVolume?: string
  transactions?: string
  avg?: string
  noData?: string
}

export const DEFAULT_GEOGRAPHIC_DISTRIBUTION_CHART_LABELS: GeographicDistributionChartLabels =
  {
    activeCantons: 'Active Cantons',
    totalTransactions: 'Total Transactions',
    avgTransactionPrice: 'Avg Transaction Price',
    totalMarketVolume: 'Total Market Volume',
    transactionsByCanton: 'Transactions by Canton',
    topCitiesByVolume: 'Top Cities by Transaction Volume',
    transactions: 'transactions',
    avg: 'Avg',
    noData: 'No data available',
  }

export interface GeographicDistributionChartProps {
  data: GeographicDistributionData | null
  loading?: boolean
  error?: string | null
  labels?: Partial<GeographicDistributionChartLabels>
}
